import { FormQuestionFormat } from "../../types/FormQuestionFormat"

type ReferralData = Record<string, any>

export const transformReferralKeys = (
  formats: FormQuestionFormat[],
  referral: ReferralData,
): Record<string, any> => {
  const result: Record<string, any> = {}

  formats.forEach((format) => {
    let value = referral[format.mapped_field]
    // there are some cases where referral columns are not exactly the same as the results so we handle it here
    if (format.mapped_field === "interpreter_required") {
      value = referral["intepreter_required"]
    }

    if (format.mapped_field === "primary_care_provider_fax_number") {
      value = referral["primary_care_fax"]
    }

    if (value !== undefined) {
      result[format.prompt_en] = value
    }
  })

  return result
}
